import React from 'react';
const testimonials = [{
  initials: 'RG',
  quote: 'Compré un domingo. El lunes entré a la pileta con todo listo. Primera vez en años que no improvisé.',
  name: 'Roberto G.',
  country: 'México 🇲🇽'
}, {
  initials: 'CM',
  quote: 'Mis alumnos principiantes adultos nunca habían llegado al primer largo. Con el Tomo 6 lo lograron en 8 semanas.',
  name: 'Camila M.',
  country: 'Colombia 🇨🇴'
}, {
  initials: 'JA',
  quote: 'Antes armaba cada sesión desde cero. Ahora abro el tomo, leo la sesión y entro al agua. 5 minutos máximo.',
  name: 'Javier A.',
  country: 'Chile 🇨🇱'
}, {
  initials: 'PV',
  quote: 'Los reportes mensuales del Business Pro eliminaron las quejas de padres. Ahora preguntan cuándo pasa al siguiente nivel.',
  name: 'Patricia V.',
  country: 'Perú 🇵🇪'
}, {
  initials: 'AS',
  quote: 'Mi tasa de retención pasó del 35% al 85% con el sistema de gestión. Nunca pensé que eso era posible en natación.',
  name: 'Andrés S.',
  country: 'España 🇪🇸'
}, {
  initials: 'LR',
  quote: 'El Bono 4 de Scripts transformó cómo hablo con los padres. Ahora me perciben como el experto que soy.',
  name: 'Lucía R.',
  country: 'Ecuador 🇪🇨'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-[#0A0A0F] py-14 px-4" data-id="element-213">
      <div className="max-w-3xl mx-auto" data-id="element-214">
        <div className="text-center mb-8" data-id="element-215">
          <h2 className="text-2xl sm:text-3xl font-black text-white mb-1" data-id="element-216">
            Lo que dicen los <span className="text-[#FF6B00]" data-id="element-217">profesores</span>
          </h2>
          <p className="text-[#B0B0C0] text-sm" data-id="element-218">
            ⭐⭐⭐⭐⭐ 4.9/5 · +500 profesores en 15 países
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-219">
          {testimonials.map(t => <div key={t.initials} className="bg-[#16161F] border border-[#FF6B0033] rounded-xl px-4 py-3.5 flex items-start gap-3" data-id="element-220">
              <div className="w-9 h-9 rounded-full bg-[#FF6B00] flex items-center justify-center text-white font-black text-xs flex-shrink-0 mt-0.5" data-id="element-221">
                {t.initials}
              </div>
              <div className="flex-1 min-w-0" data-id="element-222">
                <p className="text-white text-xs sm:text-sm leading-relaxed italic mb-1.5" data-id="element-223">
                  "{t.quote}"
                </p>
                <p className="text-[10px] sm:text-xs" data-id="element-224">
                  <span className="text-white font-bold" data-id="element-225">{t.name}</span>
                  <span className="text-[#FF6B00] font-medium" data-id="element-226">
                    {' '}
                    · {t.country}
                  </span>
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}